import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Filter, GroupCard, NoInformation } from '../../index';

import {
    StyledSessionTableContainer,
    StyledSessionTableHeader,
    StyledSessionTableBody,
} from './style';

import { alertError } from '../../../redux/stateActions';
import { GET_OPEN_SESSIONS } from '../../../services/provider';

dayjs.extend(objectSupport);

const OpenSession = ({ staffOptions, selectedStaff, setSelectedStaff }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state) => state.user);

    /*--------------- Get Open session ---------------*/
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [openSession, setOpenSession] = useState([]);

    const variables = useMemo(() => {
        const newVariables = {
            hospital: user.staff.hospital.id,
            startDate: startDate,
            endDate: endDate,
        };

        if (selectedStaff !== '') {
            newVariables.staff = selectedStaff;
        }
        return newVariables;
    }, [selectedStaff, startDate, endDate]);

    const { data: getOpenSessionData, error: getOpenSessionError } = useQuery(GET_OPEN_SESSIONS, {
        variables: variables,
        skip: _.isEmpty(user) || !startDate || !endDate,
        fetchPolicy: "network-only",
    });

    useEffect(() => {
        if (getOpenSessionError) {
            dispatch(alertError(`Cannot get Open session: ${getOpenSessionError.message}`));
        }

        if (getOpenSessionData) {
            setOpenSession(getOpenSessionData.sessions);
        }
    }, [getOpenSessionError, getOpenSessionData]);

    const handleFilterChange = ({ isToday, selectedMonth, selectedYear }) => {
        if (isToday) {
            setStartDate(dayjs().startOf('date').format('YYYY-MM-DD'));
            setEndDate(dayjs().endOf('date').format('YYYY-MM-DD'));
        } else {
            setStartDate(
                dayjs()
                    .set({ month: selectedMonth, year: selectedYear })
                    .startOf('month')
                    .format('YYYY-MM-DD')
            );
            setEndDate(
                dayjs()
                    .set({ month: selectedMonth, year: selectedYear })
                    .endOf('month')
                    .format('YYYY-MM-DD')
            );
        }
    };

    const handleRedirect = (id) => {
        history.push({
            pathname: `/provider/session/open/${id}`,
            state: {
                prevPath: history.location.pathname,
                prevTab: 3,
            },
        });
    };

    return (
        <StyledSessionTableContainer>
            <StyledSessionTableHeader>
                <Filter
                    name="All Events"
                    onChange={handleFilterChange}
                    staffOptions={staffOptions}
                    selectedStaff={selectedStaff}
                    setSelectedStaff={setSelectedStaff}
                />
            </StyledSessionTableHeader>
            <StyledSessionTableBody style={{ rowGap: '13px' }}>
                {!_.isEmpty(openSession) ? (
                    openSession.map((session) => (
                        <GroupCard key={session.id} data={session} onClick={handleRedirect} />
                    ))
                ) : (
                    <NoInformation />
                )}
            </StyledSessionTableBody>
        </StyledSessionTableContainer>
    );
};

OpenSession.propTypes = {
    staffOptions: PropTypes.arrayOf(PropTypes.object),
    selectedStaff: PropTypes.string.isRequired,
    setSelectedStaff: PropTypes.func.isRequired,
};

export default OpenSession;
